interface LoadingMarkProps {
  readonly class?: string;
  readonly compact?: boolean;
  readonly label?: string;
}

const BRAND_BASE = `${import.meta.env.BASE_URL}brand/`;

export function LoadingMark({
  class: className,
  compact = false,
  label = 'Loading coaster',
}: LoadingMarkProps) {
  return (
    <span
      class={`loading-mark ${compact ? 'loading-mark-compact' : ''} ${className ?? ''}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span class="loading-mark-motion" aria-hidden="true">
        <img class="loading-mark-loop" src={`${BRAND_BASE}loading-loop.png`} alt="" />
        <span class="loading-mark-train-orbit">
          <img class="loading-mark-train" src={`${BRAND_BASE}loading-train.png`} alt="" />
        </span>
      </span>
      <span class="loading-mark-label">{label}</span>
    </span>
  );
}
